import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Admin_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { RootState } from '../reducers';
import { useNavigate } from 'react-router-dom';
import { getData, AddData, updateData, removeData } from '../reduxactions/adminactions/AdminCountryAction';
export const AdminCountry = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')
    const dispatch = useDispatch();
    const getcontry = async () => {
        try {
            await dispatch(getData() as any);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffectOnce(() => {
        getcontry()

    }, []);
    const data = useSelector((state: RootState) => state.countrydata.data);
    // const [countryname, setCountryname] = useState('');
    // const [countrylabel, setCountrylabel] = useState('');

    // useEffect(() => {
    //     if (data.length > 0) {
    //         setCountryname(data[0].CountryName);
    //         setCountrylabel(data[0].countrylabel);

    //     }
    //   }, [data]);

    const addcontry = useSelector((state: RootState) => state.countrydata.addcontry);
    const toast = useRef(addcontry)
    const [cname, setCname] = useState('');
    const [clabel, setClabel] = useState('');
    const [addDilog, setaddDilog] = useState(false);
    const addDataAsync = async () => {
        try {
            // await dispatch(AddData(cname, clabel) as any);
            const payload = { cname: cname, clabel: clabel, q: 2 };
            const apiname = Admin_API.country_API;
            const response = await LoginService.getData(apiname, payload);
            toast.current.show({ severity: 'success', summary: 'Added Successfully', detail: '', life: 3000 });
            getcontry();
            setaddDilog(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const close = async () => {
        setaddDilog(false);
        setupdateDilog(false);
        setDeleteConfirmation(false);

    }
    const [updateDilog, setupdateDilog] = useState(false);
    const [editData, setEditData] = useState({
        CountryName: '',
        countrylabel: '',
        CountryID: '',

    });
    const editupload = (rowData: any) => {
        setEditData({
            CountryName: rowData.CountryName,
            countrylabel: rowData.countrylabel,
            CountryID: rowData.CountryID

        });
        setupdateDilog(true);
    }
    const updatedata = useSelector((state: RootState) => state.countrydata.updatedata);
    const toast1 = useRef(updatedata);
    const updateDataAsync = async () => {
        try {
            const CountryName = editData.CountryName
            const countrylabel = editData.countrylabel
            const CountryID = editData.CountryID
            await dispatch(updateData(countrylabel, CountryName, CountryID) as any);
            toast1.current.show({ severity: 'success', summary: 'Update Successfully', detail: '', life: 3000 });
            getcontry();
            setupdateDilog(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const remove = useSelector((state: RootState) => state.countrydata.remove);
    const toast3 = useRef(remove);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);

    const [removedata, setRemoveData] = useState({
        CountryID: '',
    });

    const Removeduring = (rowData: any) => {
        setRemoveData({
            CountryID: rowData.CountryID,
        });
        setDeleteConfirmation(true);
    }
    const confirmDelete = async () => {
        const { CountryID } = removedata;

        await dispatch(removeData(CountryID) as any);
        toast3.current.show({ severity: 'error', summary: 'Successfully Delete.', life: 3000 });
        setDeleteConfirmation(false);
        getcontry()
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/admincountry.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="content-wrapper" style={{ marginLeft: '100px' }}>
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-6">
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content" style={{ marginLeft: '110px' }} >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2" style={{ marginTop: '50px' }}>
                                <h2>Country List</h2>
                            </div>
                            <div className="col-16" style={{ textAlign: "right" }}>
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>
                            <br></br>
                            <div className="card flex flex-wrap justify-content-end" style={{ marginRight: '30px' }}>
                                <Button label="Add Country" severity="info" onClick={() => setaddDilog(true)} />
                            </div>
                            <div className="box box-primary">
                                <div className="card">
                                    <p className="m-0">
                                        <div>
                                            <div className="card flex flex-wrap justify-content">
                                                <span className="p-input-icon-left">
                                                    <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                                                    <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                                                </span>
                                            </div>
                                            <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                globalFilterFields={['CountryName', 'countrylabel']}  >
                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                <Column field="CountryName" sortable header="Country Name"></Column>
                                                <Column field="countrylabel" sortable header="Country Label"></Column>

                                                <Column header="Operation" body={(rowData) => (
                                                    <>
                                                        <Button className='mr-2' tooltip="Edit" severity="info" rounded outlined icon="pi pi-pencil" onClick={() => editupload(rowData)} />
                                                        <Button icon="pi pi-trash" tooltip="Delete" rounded outlined className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'red' }} onClick={() => Removeduring(rowData)} />

                                                    </>

                                                )} />
                                            </DataTable>

                                        </div>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Dialog header="Add Country" visible={addDilog} style={{ width: '35vw', height: '40vh' }} onHide={() => setaddDilog(false)} >
                <div className="grid pt-1">
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Country Name:</label>
                    </div>
                    <div className="col-6" >
                        <InputText id="name" style={{ width: '18vw' }} name="Contest Name" placeholder='Enter Name' onChange={(e) => setCname(e.target.value)} />

                    </div>
                </div>

                <div className="grid pt-2">
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Country Label:</label>
                    </div>
                    <div className="col-6" >
                        <InputText id="amount" style={{ width: '18vw' }} name="amount" placeholder='Country Label' onChange={(e) => setClabel(e.target.value)} />

                    </div>
                </div>


                <Button label="Close" onClick={close} severity="secondary" style={{ marginTop: '10px' }} />
                <Button label="Add" onClick={addDataAsync} style={{ float: 'right', marginTop: '10px' }} />
            </Dialog >
            <Dialog header="Update Country" visible={updateDilog} style={{ width: '35vw', height: '40vh' }} onHide={() => setupdateDilog(false)} >
                <div className="grid pt-1">
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Country Name:</label>
                    </div>
                    <div className="col-6" >
                        <InputText id="name" style={{ width: '18vw' }} name="Doctitle" onChange={(e) => setEditData({ ...editData, CountryName: e.target.value })} value={editData.CountryName} />

                    </div>
                </div>

                <div className="grid pt-3">
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Country Label:</label>
                    </div>
                    <div className="col-6" >
                        <InputText id="labe" style={{ width: '18vw' }} name="Doctitle" onChange={(e) => setEditData({ ...editData, countrylabel: e.target.value })} value={editData.countrylabel} />

                    </div>
                </div>


                <Button label="Close" onClick={close} severity="secondary" style={{ marginTop: '10px' }} />
                <Button label="Update" onClick={updateDataAsync} style={{ float: 'right', marginTop: '10px' }} />
            </Dialog >
            < Dialog header="Confirm Delete" style={{ width: '30vw' }} visible={deleteConfirmation} onHide={() => setDeleteConfirmation(false)}>
                <div>Are you really want to Remove...?</div>
                <br></br>
                <Button label="Delete" icon="pi pi-check" className='mr-3 p-button-raised' onClick={confirmDelete} />
                <Button label="Close" icon="pi pi-times" onClick={close} className="mr-3 p-button-secondary" />
            </Dialog >
            <Toast ref={toast} >
                <Message severity="success" content={addcontry} />
            </Toast>

            <Toast ref={toast1} >
                <Message severity="success" content={updatedata} />
            </Toast>
            <Toast ref={toast3} >
                <Message severity="error" content={remove} />
            </Toast>



        </div>
    )
}
